'use client'

import { ReactElement } from 'react'
import { ListPriceItems } from '@/components/cart/list-price-items'
import { LayoutDiscount } from '@/components/layout/layout-discount'
import { PaymentDetail } from '@/components/cart/payment-detail'
import { useProductStore } from '@/hooks/use-cart-product/store'
import {
  productFieldsSelector,
  productsSelector,
  promotionCodeSelector,
  selectedUpSellingSelector,
  upSellingProductsSelector,
} from '@/hooks/use-cart-product/selectors'
import SlidingDiv from '@/components/layout/sliding-div'
import { useOutsideClick } from '@/hooks/use-outside-click'
import { usePaymentStore } from '@/hooks/use-payment-controller/store'
import {
  isDetailOpenSelector,
  setDetailOpenSelector,
} from '@/hooks/use-payment-controller/selectors'
import * as React from 'react'

export function SubscriptionCartDetail({ children }): ReactElement {
  const isDetailOpen = usePaymentStore(isDetailOpenSelector)
  const setDetailOpen = usePaymentStore(setDetailOpenSelector)
  const products = useProductStore(productsSelector)
  const promo = useProductStore(promotionCodeSelector)
  const productStore = useProductStore(productFieldsSelector)
  const prodSelected = productStore.currentProducts

  const closeNavBar = () => {
    setDetailOpen(false)
  }

  const ref = useOutsideClick(closeNavBar)

  if (!isDetailOpen) return <>{children}</>

  return (
    <>
      <div className="relative w-full bg-white">
        <div className="md:hidden">
          <SlidingDiv>
            <div
              className="flex h-[calc(100vh-65px)] w-full max-w-[1440px] flex-col bg-white md:p-4"
              ref={ref}>
              <div className="flex flex-col space-y-5 bg-[#D9D9D9] bg-opacity-15 p-4">
                <p className={'text-base font-normal'}>ESTÁS COMPRANDO</p>
                {products &&
                  prodSelected.productsList.map((product, index) => {
                    return (
                      <ListPriceItems
                        key={index}
                        ninjaIconName={product.academy}
                        priceTitle={product.title}
                        priceSubTitle={product.subTitle}
                        price={product.amount || 0}
                        detail={true}
                      />
                    )
                  })}
              </div>

              <hr className="border-1 border-checkout-bk-op20" />
              <div className="space-y-5 p-4">
                {!promo?.code && <LayoutDiscount openDetail={false} />}
                <PaymentDetail
                  prods={prodSelected}
                  amount={prodSelected?.totalAmount || 0}
                  subscription={prodSelected?.subscriptionAmount || 0}
                  period={prodSelected?.period}
                />
              </div>
            </div>
          </SlidingDiv>
          <div className="absolute inset-0 z-10 bg-black opacity-50"></div>
        </div>
        {/*{children}*/}
      </div>
    </>
  )
}
